import { PropTypes } from 'react-desc';

var props = {
  /** props injected to wrapper of page header */
  containerProps: PropTypes.shape({}).description('props injected to wrapper of page header'),

  /** inner ref for input group wrapper */
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]).description('inner ref for input group wrapper'),

  /** class for input group wrapper */
  className: PropTypes.string.description('class for input group wrapper'),

  /**
   * Set style for the input group
   */
  style: PropTypes.object.description('Set style for the input group'),

  /**
   * Component to be added at the left side of the input
   */
  leftAddon: PropTypes.element.description('Component to be added at the left side of the input'),

  /**
   * Component to be added at the right side of the input
   */
  rightAddon: PropTypes.element.description('Component to be added at the right side of the input'),

  /**
   * Input components to show
   */
  children: PropTypes.element.description('Input components to show')
};

export { props };
//# sourceMappingURL=props.js.map
